module.exports = __webpack_public_path__ + "img/tabIcNewsOff.bd604026.svg";